import { listAssessmentInvites } from 'js/actions/assessment-invite-actions';
import { selectAssessmentInvitesQuery } from 'js/store/reducers/queries';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import AssessmentReviewDetail from '../components/Review/AssessmentReviewDetail';
import { useUpdateBreakouts } from 'js/hooks/useUpdateBreakouts';

function LiveAssessmentReviewDetailContainer({
  listAssessmentInvites,
  assessmentInvitesQueryResult,
  currentWorkspaceId,
  teamId,
  assessmentKey,
  assessments,
  match,
  ...props
}) {
  const assessmentId = match.params.assessmentId;
  const resolvedAssessmentKey =
    assessmentKey ||
    assessments?.find((a) => String(a.id) === String(assessmentId))?.key;

  const { handleUpdateBreakouts, savingBreakouts } = useUpdateBreakouts({
    assessmentId,
    assessmentKey: resolvedAssessmentKey,
    teamId,
  });

  useEffect(() => {
    listAssessmentInvites(currentWorkspaceId, teamId, assessmentId);
  }, [listAssessmentInvites, currentWorkspaceId, teamId, assessmentId]);

  return (
    <AssessmentReviewDetail
      {...props}
      match={match}
      assessments={assessments}
      assessmentKey={resolvedAssessmentKey}
      teamId={teamId}
      assessmentInvitesQueryResult={assessmentInvitesQueryResult}
      onUpdateBreakouts={handleUpdateBreakouts}
      savingBreakouts={savingBreakouts}
    />
  );
}

export default connect(
  (store, params) => ({
    currentWorkspaceId: store.currentWorkspaceId,
    assessmentInvitesQueryResult: selectAssessmentInvitesQuery(
      store,
      params.match.params.assessmentId
    ),
  }),
  { listAssessmentInvites }
)(LiveAssessmentReviewDetailContainer);
